import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class NavShareService {
    private collapseState = true;

    sidebarCollapsed$ = new BehaviorSubject<boolean>(this.collapseState);

    toggleCollapseState() {
        this.collapseState = !this.collapseState;
        this.sidebarCollapsed$.next(this.collapseState);
    }
}
